import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { confirmPassword } from 'auth/AwsAuth'
import { NmFormTextField } from 'shared/NmForm/NmFormTextField'
import { NmForm } from 'shared/NmForm'
import { NmFormText } from 'shared/NmForm/NmFormText'
import { NmFormSubmitGroup } from 'shared/NmForm/NmFormSubmitGroup'
import { NmFormButton } from 'shared/NmForm/NmFormButton'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { AuthErrorCode } from 'auth/ConstErrorCode'

const useStyles = (theme) => ({
  root: {
    margin: '0 auto 0',
    padding: '10px',
    maxWidth: '480px',
    justifyContent: 'center'
  },
  isConsent: {
    paddingBottom: theme.spacing(1)
  },
  consentHelperText: {
    minHeight: 0,
    margin: 0
  }
})

const schema = Yup.object().shape({
  email: Yup.string()
    .required('必須項目です')
    .email('メールアドレスの形式が正しくありません'),
  code: Yup.string().required('必須項目です'),
  password: Yup.string()
    .required('必須項目です')
    .min(8, 'パスワードは8文字以上で入力してください')
    .matches(
      /^(?=.*?[a-z])(?=.*?\d)[a-zA-Z\d!-/:-@[-`{-~]{8,99}$/,
      '半角英数字を組み合わせて入力してください'
    ),
  passwordConfirm: Yup.string()
    .required('必須項目です')
    .oneOf([Yup.ref('password')], 'パスワードと一致していません')
})

const Form = (props) => {
  const { classes, ...defaultValues } = props
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting }
  } = useForm({
    defaultValues: {
      email: defaultValues.email,
      code: '',
      password: '',
      passwordConfirm: ''
    },
    resolver: yupResolver(schema)
  })

  const onSubmit = (values) => {
    confirmPassword(values.email, values.code, values.password)
      .then((result) => {
        window.location.href = '/ResetPasswordComplete'
      })
      .catch((err) => {
        switch (err.message) {
          case AuthErrorCode.UserNotFoundError:
            setError('email', {
              type: 'manual',
              message: 'このメールアドレスは登録されていません'
            })
            break
          case AuthErrorCode.ExpiredCodeError:
          case AuthErrorCode.CodeMismatchError:
            setError('code', {
              type: 'manual',
              message: '認証コードが正しくありません'
            })
            break
          default:
            setError('email', {
              type: 'manual',
              message:
                'エラーが発生しました。大変お手数ですがお問い合わせください'
            })
        }
      })
  }

  return (
    <Grid className={classes.root}>
      <Grid>
        <NmForm
          title='認証コードを送信しました'
          onSubmit={handleSubmit(onSubmit)}
        >
          <NmFormText>
            メールに記載されている認証コードを入力し、新しいパスワードを入力してください。
          </NmFormText>
          <NmFormTextField
            name='email'
            label='メールアドレス'
            {...register('email')}
            error={Boolean(errors.email)}
            helperText={errors?.email?.message}
          />
          <NmFormTextField
            name='code'
            label='認証コード'
            {...register('code')}
            error={Boolean(errors.code)}
            helperText={errors?.code?.message}
          />
          <NmFormTextField
            name='password'
            label='新しいパスワード'
            type='password'
            {...register('password')}
            error={Boolean(errors.password)}
            helperText={errors?.password?.message}
          />
          <NmFormTextField
            name='passwordConfirm'
            label='新しいパスワード(確認用)'
            type='password'
            {...register('passwordConfirm')}
            error={Boolean(errors.passwordConfirm)}
            helperText={errors?.passwordConfirm?.message}
          />
          <NmFormSubmitGroup>
            <NmFormButton title='送信する' disabled={isSubmitting} />
          </NmFormSubmitGroup>
        </NmForm>
      </Grid>
    </Grid>
  )
}

export const Body = withStyles(useStyles)(Form)
